import React, {useEffect, useState} from 'react';
import {apiErrorRaised, useApiErrorDispatch} from "../../context/api_error/ApiErrorIndex";
import {Button, Card, CardBody, Table} from "reactstrap";
import {Auth} from "../../services/api/Auth";
import {useParams} from 'react-router-dom';
import UserAccessItem from "./UserAccessItem";
import Paginator from "../Pagination/Paginator";
import {useTableFiltersState} from "../../context/table_filters/TableFiltersContext";

const UserAccessesList = () => {
  const {userId} = useParams();
  const dispatch = useApiErrorDispatch();
  const [deletedUserAccess, setDeletedUserAccess] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [userAccessList, setUserAccessList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isFiltersCollapsed, setFiltersCollapsed] = useState(true);
  const tableFilters = useTableFiltersState();

  // Load user accesses
  const loadUserAccesses = () => {
    setLoading(true);
    const params = {
      limit: limit,
      offset: offset,
      filters: tableFilters
    };

    Auth.user_accesses(userId, params).then((r) => {
      setLoading(false);
      if (r?.status < 400) {
        setUserAccessList(r.data.user_accesses || []);
        setPagination(r.data.pagination || {});
      } else {
        apiErrorRaised(dispatch, r?.response);
      }
    });
  };

  // Effect to reload user accesses when dependencies change
  useEffect(() => {
    loadUserAccesses();
  }, [dispatch, tableFilters, limit, offset, deletedUserAccess, userId]);

  // Reset deleted flag after reloading
  useEffect(() => {
    if (deletedUserAccess) {
      setDeletedUserAccess(false);
    }
  }, [userAccessList, deletedUserAccess]);

  const handleClick = (e, offset, limit) => {
    e.preventDefault();
    setLimit(limit);
    setOffset(offset);
  };

  const toggleCollapsed = () => {
    setFiltersCollapsed(!isFiltersCollapsed);
  };

  return (
    <>
      <div className={'view_header'}>
        <div className={'title'}>
          <h1>User Accesses</h1>
        </div>
        <div className={'button_actions'}>
          <Button outline color="primary"
                  onClick={toggleCollapsed}>
            <span className="fa-filter fa me-1"/>
            Filters
          </Button>
        </div>
      </div>

      {userAccessList.length === 0 && !isLoading ? (
        <Card className="mt-3">
          <CardBody>
            <p className="mb-0">No company accesses found for this user.</p>
          </CardBody>
        </Card>
      ) : (
        <div className="mt-3">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
            <tr>
              <th scope="col">Company</th>
              <th scope="col">Role</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
            {isLoading ? (
              <tr>
                <td>
                  <span className="spinner-border spinner-border-lg me-1"/>
                </td>
              </tr>
            ) : (
              userAccessList.map((access, i) => (
                <UserAccessItem
                  key={i}
                  access={access}
                  setDeletedUserAccess={setDeletedUserAccess}
                />
              ))
            )}
            </tbody>
          </Table>
        </div>
      )}
      <Paginator
        pagination={pagination}
        handleClick={handleClick}
        offset={offset}
        limit={limit}
      />
    </>
  );
};

export default UserAccessesList;
